import { __assign } from '../../../_virtual/_tslib.js';
import { Collapse } from '@mui/material';
import React, { useRef, useEffect } from 'react';
import { useToggleState } from '../../../utils/common/dataTypes/boolean.js';

var ReadMoreWrapper = function (_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.collapsedHeight, collapsedHeight = _c === void 0 ? 50 : _c, ExpandToggleButton = _a.ExpandToggleButton, _d = _a.childDivProps, childDivProps = _d === void 0 ? {} : _d;
    var _e = useToggleState(true), expandCollapseFunctionalityIsEnabled = _e[0], enableExpandCollapseFunctionality = _e[1], disableExpandCollapseFunctionality = _e[2];
    var _f = useToggleState(false), isExpanded = _f[0], collapse = _f[2], toggleIsExpanded = _f[3];
    var ref = useRef(null);
    useEffect(function () {
        if (expandCollapseFunctionalityIsEnabled && isExpanded)
            return; // dont need to collapse on content change if already expanded
        if (ref.current) {
            if (ref.current.clientHeight > collapsedHeight) {
                enableExpandCollapseFunctionality();
                collapse();
            }
            else {
                disableExpandCollapseFunctionality();
            }
        }
    }, [children, childDivProps]); // the content might change
    var baseElement = (React.createElement("div", __assign({ ref: ref }, childDivProps), children));
    return expandCollapseFunctionalityIsEnabled ? (React.createElement(React.Fragment, null,
        React.createElement(Collapse, { collapsedSize: collapsedHeight, in: isExpanded }, baseElement),
        React.createElement(ExpandToggleButton, { onClick: toggleIsExpanded, isExpanded: isExpanded }))) : (baseElement);
};

export { ReadMoreWrapper as default };
//# sourceMappingURL=ReadMoreWrapper.js.map
